import React, { useEffect } from 'react'
import Banner from '../landing/main-banner/Banner'
import Footer from '../landing/footer/Footer'
import Benifits from './Benifits/Benifits'
import Working from './working/Working'
import Evolve from '../landing/Evolvetomi/Evolve'
import Getapp from './getapp/Getapp'
import Bannerchatandrepay from './Bannerchatandrepay'
import Faqschatandrepay from './Faqs/Faqschatandrepay'

export const Chatandpaylanding = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
useEffect(() => {
  document.title = "Secure texting & Payments - tomi ";

  const metaDescription = document.querySelector("meta[name='description']");
  if (metaDescription) {
    metaDescription.setAttribute("content", "Secure text message and payments together in one decentralized wallet, allowing you to transact as naturally as you chat - tomi");
  } else {
    const meta = document.createElement("meta");
    meta.name = "description";
    meta.content = "Secure text message and payments together in one decentralized wallet, allowing you to transact as naturally as you chat - tomi";
    document.head.appendChild(meta);
  }
}, []);
  return (
    <>
      <Bannerchatandrepay />
      <Benifits />
      <Working />
      <Faqschatandrepay />
      <Evolve />
      <Getapp />
      <Footer />
    </>
  )
}
